
import XButton from 'vux/src/components/x-button/index.vue'

import { local } from '@/tools/storage'
import { mapActions, mapMutations } from 'vuex'
export default {
components: {
XButton
},
methods: {
...mapActions({
logoutCommit: 'logout'
}),
...mapMutations({
resetUserInfo: 'resetLoginUserInfo'
}),
toResetAccount () {
this.$router.push('/carbonAccount/trail?step=3')
},
toLogout () {
this.logoutCommit()
this.resetUserInfo()

let localReadInterval = local.get('READ_INTERVAL', true)
if (localReadInterval) {
window.clearInterval(localReadInterval)
localReadInterval = null
local.remove('READ_INTERVAL')
}
this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
this.$ga.trackEvent('user', 'logout', '')
}
}
}
